import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getStatusCardCollapsibleSectionStyles = () => {
  return StyleSheet.create({
    container: {
      alignSelf: 'flex-start',
      width: '100%'
    },
    innerContainer: {
      paddingHorizontal: tokens.spacing.SPACING_20
    },
    topMargin: {
      width: '100%',
      marginTop: tokens.spacing.SPACING_20
    },
    subtitle: {
      marginTop: tokens.spacing.SPACING_4
    },
    row: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      marginTop: tokens.spacing.SPACING_20,
      alignItems: 'center'
    },
    rowContent: {
      flex: 1
    },
    actions: {
      flexShrink: 0,
      marginLeft: tokens.spacing.SPACING_14,
      alignItems: 'flex-end',
      alignSelf: 'flex-end'
    }
  });
};